import React, {Component} from 'react';
import {Collapse} from '@material-ui/core';
import {ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon} from '@material-ui/icons';

const DIR_SYMBOL = {forward: '→', backward: '←', bidirectional: '↔'};

const resolveRef = (ref, nameIndex) => {
  if (!ref) return '—';
  const {nodeId, tableId, elementId} = ref;
  const nodeName = nameIndex[nodeId] || nodeId;
  const tableName = tableId ? (nameIndex[tableId] || tableId) : null;
  const elName = nameIndex[elementId] || elementId;
  return tableName ? `${nodeName} · ${tableName} · ${elName}` : `${nodeName} · ${elName}`;
};

/**
 * Read-only mappings table (editing is graph-view-only). Cross-node mappings sit in
 * the main table; intra-node mappings (source and target in the same node) are grouped
 * under a collapsible "Within <node>" section. The collapse toggle is read-only.
 */
class MappingsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _toggleIntra(nodeId) {
    this.setState((s) => ({[`intra_${nodeId}`]: !s[`intra_${nodeId}`]}));
  }

  render() {
    const {crossRows, intraByNode, nameIndex} = this.props;
    const intraNodeIds = Object.keys(intraByNode || {});

    return (
      <div className="lt-section">
        <div className="lt-section-header">
          <span className="lt-section-title">Mappings</span>
        </div>

        <table className="data-table lt-table">
          <thead>
            <tr>
              <th>Source</th>
              <th>Direction</th>
              <th>Target</th>
              <th>Transformation</th>
            </tr>
          </thead>
          <tbody>
            {crossRows.length === 0 && intraNodeIds.length === 0 && (
              <tr><td colSpan={4} className="lt-empty-row">No mappings.</td></tr>
            )}
            {crossRows.map((m) => (
              <tr key={m.id} data-testid={`lt-map-row-${m.id}`}>
                <td>{resolveRef({nodeId: m.sourceNodeId, tableId: m.sourceTableId, elementId: m.sourceElementId}, nameIndex)}</td>
                <td>{DIR_SYMBOL[m.direction] || '→'}</td>
                <td>{resolveRef({nodeId: m.targetNodeId, tableId: m.targetTableId, elementId: m.targetElementId}, nameIndex)}</td>
                <td>{m.transformation || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {intraNodeIds.map((nodeId) => {
          const nodeName = nameIndex[nodeId] || nodeId;
          const open = !!this.state[`intra_${nodeId}`];
          const intraRows = intraByNode[nodeId] || [];
          return (
            <div key={nodeId} className="lt-intra-section">
              <button className="lt-intra-toggle" onClick={() => this._toggleIntra(nodeId)}>
                {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                <span>{`Within ${nodeName}`}</span>
                <span className="lt-intra-count">{intraRows.length}</span>
              </button>
              <Collapse in={open}>
                <table className="data-table lt-table lt-intra-table">
                  <thead>
                    <tr>
                      <th>Source Element</th>
                      <th>Direction</th>
                      <th>Target Element</th>
                      <th>Transformation</th>
                    </tr>
                  </thead>
                  <tbody>
                    {intraRows.map((m) => (
                      <tr key={m.id} data-testid={`lt-map-row-${m.id}`}>
                        <td>{resolveRef({nodeId: m.sourceNodeId, tableId: m.sourceTableId, elementId: m.sourceElementId}, nameIndex)}</td>
                        <td>{DIR_SYMBOL[m.direction] || '→'}</td>
                        <td>{resolveRef({nodeId: m.targetNodeId, tableId: m.targetTableId, elementId: m.targetElementId}, nameIndex)}</td>
                        <td>{m.transformation || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Collapse>
            </div>
          );
        })}
      </div>
    );
  }
}

export default MappingsTable;
